import { useQuery } from "@tanstack/react-query"

import { CUSTOMER_TYPE_QUERY_KEY } from "@/constants/query"

const MOCK_DATA = [
    {
        id: 0,
        name: "Юридическое лицо"
    },
    {
        id: 1,
        name: "Индивидуальный предприниматель"
    }
]

export const useCustomerTypeQuery = () => {
    return useQuery({
        queryFn: () => MOCK_DATA,
        queryKey: [CUSTOMER_TYPE_QUERY_KEY]
    })
}